import { memo } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';

import Render from 'components/render';
import { RECAPTCHA_SITE_KEY } from 'constants/constants';
import { useGrowthbookFeatureValue } from 'growthbook';
import { gRecaptchaSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

import { setRecaptchaRef } from '../../helpers/recaptchaSingleton';

import './recaptchaRoot.scss';

// * need to keep one global recaptcha instance to avoid - https://github.com/google/recaptcha/issues/269
// * & prevent mulitple dom nodes being created eveytime component is re-rendered, we cant change any props except "hidden" prop
// * this might get resolved once we migrate to v3 recaptcha later

export const RecaptchaRoot = memo(() => {
  const isInitialised = useAppSelector(state => gRecaptchaSelector(state).initialised);
  const isHidden = useAppSelector(state => gRecaptchaSelector(state).hidden);
  const isRecaptchaSingletonEnabled = useGrowthbookFeatureValue<boolean>(
    'is_recaptcha_singleton_enabled'
  );

  return (
    <Render when={!!RECAPTCHA_SITE_KEY && isRecaptchaSingletonEnabled && isInitialised}>
      <ReCAPTCHA
        ref={setRecaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY!}
        size="invisible"
        theme="dark"
        badge="bottomleft"
        data-testid="recaptcha-root"
        hidden={isHidden}
      />
    </Render>
  );
});
